
import api from '~api'
import setting from '../../../server/settings'
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "delay",
components: {
XHeader
},
data() {
return {
title: "收费",
data:[]
}
},
mounted(){
this.getData()
},
methods:{
backHome(){
this.$router.push({name:'home'})
},
getData(){

api.post("/findScore/queryitems", {"idCard": this.$store.state.stu_idcard}).then( res=>{
if(res.data.code == '0'){
if(res.data.data.length<=0){
this.$msgbox('温馨提示：', "暂无可缴费信息");
this.$vux.loading.hide();
}else{
this.data = res.data.data;
}
}
})
},
gotoPay(item){
this.$router.push({name:'rechargePay', params:{detail:item}});
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/recharge.vue